import React from 'react';
import EventDispatcher from '../core/EventDispatcher';

export enum TransitionEvent
{
	OUT_COMPLETE,
	IN_COMPLETE,
}

export class Transition extends React.Component
{
	trigger = new EventDispatcher<TransitionEvent>();
	public transitionOut()
	{
		this._outComplete();
	}

	outComplete()
	{

	}

	_outComplete = () =>
	{
		this.outComplete();
		this.trigger.trigger(TransitionEvent.OUT_COMPLETE);
	}

	public transitionIn()
	{
		this._inComplete();
	}

	inComplete()
	{

	}

	_inComplete = () =>
	{
		this.inComplete();
		this.trigger.trigger(TransitionEvent.IN_COMPLETE);
	}

	render()
	{
		return null;
	}

}